import { CosmicJSError } from "../../../application/domain/help/help-entity";
import { ErrorBoundary } from "../../error-boundary";
import "./help-error-boundary.scss";

export class HelpErrorBoundary extends ErrorBoundary {
  state = { error: null };

  constructor(props: any) {
    super(props);
  }

  componentDidCatch(error: Error) {
    if (CosmicJSError.isCosmicJSError(error) && error.code === "404") {
      this.setState({ error });
      return;
    }
    super.componentDidCatch(error);
  }

  componentDidMount() {
    window.addEventListener(
      "unhandledrejection",
      this.onHandledPromiseRejection,
    );
  }

  componentWillUnmount() {
    window.removeEventListener(
      "unhandledrejection",
      this.onHandledPromiseRejection,
    );
  }

  onHandledPromiseRejection = (event: PromiseRejectionEvent) => {
    event.promise.catch((error) => {
      this.setState({ error });
    });
  };

  render() {
    if (this.state.error) {
      if (CosmicJSError.isCosmicJSError(this.state.error)) {
        return (
          <div className="help-not-found-wrapper">
            <h1 className="help-not-found-title">
              お探しのページが見つかりません。
            </h1>
            <div className="help-not-found-description">
              お探しのページは一時的にアクセスができない状況にあるか、
              削除もしくは URLが変更されているため表示することができません
            </div>
            <a href="/help" className="help-return-to-top">
              トップページへ戻る
            </a>
          </div>
        );
      }
    }
    return this.props.children;
  }
}
